import { Component, Vue } from "vue-facing-decorator";
import { __vueEvent } from "../constant";
import { EVENTS } from "../enums";
import { isMobile } from "../helpers/is_mobile";
import { store } from "../store/store";

@Component
export default class Banner extends Vue {
    //#region Class properties

    //#endregion

    //#region Computed Properties

    get isMobileActive() {
        return isMobile.any() || this.$store.state.isIFrameLoaded;
    }

    get shouldShowBanner() {
        return this.$store.state.shouldShowBanner;
    }

    get bannerText() {
        return this.$store.state.bannerText;
    }

    //#endregion

    tryAgain() {
        if (store.state.bannerText === "Connecting...") {
            __vueEvent.emit(EVENTS.ConnectSignalr);
        }
    }
}
